import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { IDetalleProducto, IPreferencias, IUser } from '../interfaces/';
import { dbLocalIndex } from '../constants';
const USER_KEY = 'user';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storageGlobal: Storage | null = null;
  constructor( private storage: Storage ) {
    this.init().finally( () => console.log('Storage On') );
  }

  // Funciones para la session storage
  async clean(): Promise<void> {
    await window.sessionStorage.clear();
  }

  public saveUserSession(user: any): void {
    // window.sessionStorage.removeItem(USER_KEY);
    //window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  public getUserSession(): IUser {
    // const user = window.sessionStorage.getItem(USER_KEY);
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {correo: '', err: undefined, id: 0, idCliente: 0, invitado: false, msg: '', nombre: '', ok: false, telefono: ''};
  }
  public isLoggedIn(): boolean {
    // const user = window.sessionStorage.getItem(USER_KEY);
    const user = localStorage.getItem(USER_KEY);
    return !!user;
  }

  // Funciones para LocalStorage
  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this.storageGlobal = await this.storage.create();
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public set(key: string, value: any) {
    this.storageGlobal?.set(key, value);
  }

  async get( key: string ) {
    return await this.storage.get(key);
  }

  async delete( key: string ): Promise<void> {
    await this.storage.remove(key);
  }

  async getUser() {
    const user: IUser = await this.storage.get('user');
    return user;
  }

  async deleteUser() {
    await this.storage.remove('user');
  }

  async getCarrito() {
    const items: IDetalleProducto[] = await this.storage.get( dbLocalIndex.carrito );

    if ( !items ) {
      return [];
    }

    return items;
  }

  async getPreferencias() {
    const preferencias: IPreferencias[] = await this.storage.get( dbLocalIndex.preferenciasPedido );
    if ( preferencias ) {
      return preferencias.filter( ( item ) => {
        return item.isChecked;
      });
    } else {
      return [];
    }
  }

  async resetCarrito() {
    await this.storage.set('carrito', []);
  }
}
